<template>
  <div class="col-span-full" v-if="sections && sections.length > 0">
    <div v-for="(section, index) in sections" :key="index">
      <component
        v-if="section"
        :is="getComponent(section.name as ComponentType)"
        :ref="section.name"
        v-bind="{ ...section.props }"
      ></component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, onMounted, ref, watch, computed, onBeforeMount } from "vue";
import { getSubContentPage } from "@/util/api";
import { ISubContentPage } from "@/types/ISubContentPage";
import { defineProps } from "vue";
import { getComponent, getComponentData } from "@/util/getComponent";
import { ComponentType } from "@/util/constants";
import { parseUrl } from "@/util/helper";

const props = defineProps<{ pageId: string }>();
const { pageId } = toRefs(props);

const pageData = ref<ISubContentPage | null>(null);
const urlParams = ref<String[] | null>(null);
const currentUrl = ref<string | null>(null);
const isPreview = ref<boolean>(false);
const previewUrl = ref<string>("");

onBeforeMount(async () => {
  urlParams.value = parseUrl(window.location.href).params;
  currentUrl.value = window.location.href;
  if (!urlParams.value) return;
  let path = urlParams.value.join("/");
  //if path does not contain / replace it with previewUrl.value
  if (window !== window.top) {
    path = previewUrl.value;
    isPreview.value = true;
  }
});

onMounted(async () => {
  pageData.value = await fetchPage();
});

async function fetchPage() {
  return await getSubContentPage(pageId.value, isPreview.value);
}

watch(pageId, (value) => {
  fetchPage().then((page) => {
    pageData.value = page;
  });
});

const sections = computed(() => {
  if (!pageData.value?.properties.grid) return [];
  const sections = pageData.value?.properties.grid.items.map((item) => {
    const { content } = item;
    if (!content) return;
    return getComponentData(content);
  });
  const sanitizedSections = sections.filter(Boolean);

  return sanitizedSections;
});
</script>
